import { LocalizedHtml, useI18n } from '@udemy/i18n';
import { UDEMY_RELATIVE_LOGO_URLS } from '@udemy/react-brand-components';
import { Image } from '@udemy/react-core-components';
import { StarRating } from '@udemy/react-merchandising-components';
import classNames from 'classnames';
import React from 'react';
import styles from "./tag.module.css";
/** React prop interface for the `Tag` component */

/**
 * ### Tag
 *
 * Metadata tag component for use in Cards.
 */
export const Tag = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.tag
  }, children);
};
/** React prop interface for the `RibbonTag` component */

/**
 * ### RibbonTag
 *
 * RibbonTag component for use in Cards.
 */
export const RibbonTag = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tag, styles['ribbon-tag'])
  }, children);
};
/** React prop interface for the `RatingTag` component */

/**
 * ### RatingTag
 *
 * RatingTag component for use in Cards, that uses `StarRating` to display a numeric rating.
 */
export const RatingTag = _ref3 => {
  let {
    rating
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tag, styles.rating)
  }, /*#__PURE__*/React.createElement(StarRating, {
    numeric: true,
    rating: rating,
    size: "small"
  }));
};
/**
 * ByUdemyTag
 */

export const ByUdemyTag = () => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tag, styles['by-udemy-tag'])
  }, /*#__PURE__*/React.createElement(LocalizedHtml, {
    html: gettext('by <img class="udemyLogo" />'),
    interpolate: {
      udemyLogo: /*#__PURE__*/React.createElement(Image, {
        src: `https://www.udemy.com/${UDEMY_RELATIVE_LOGO_URLS.udemyLogoUrl}`,
        width: 37,
        height: 14,
        alt: gettext('Udemy')
      })
    }
  }));
};
//# sourceMappingURL=tag.react-component.js.map